"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenValidator = void 0;
var either_1 = require("@jawbreaker/either");
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var TokenValidator = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function TokenValidator(decode) {
        this.decode = decode;
    }
    TokenValidator.prototype.validate = function (token) {
        if (token.length <= 0) {
            return { isValid: false, reason: "EMPTY_TOKEN" };
        }
        var decodedJwt = jsonwebtoken_1.default.decode(token);
        if (decodedJwt === null) {
            return { isValid: false, reason: "INVALID_SIGNATURE" };
        }
        var data = this.decode(decodedJwt);
        if (either_1.Either.isLeft(data)) {
            return { isValid: false, reason: "INVALID_JWT_PROPERTIES" };
        }
        return {
            isValid: true,
            payload: {
                data: data.right,
                token: token,
            },
        };
    };
    return TokenValidator;
}());
exports.TokenValidator = TokenValidator;
